/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { IPropertySetter_$type } from "./IPropertySetter";
/**
 * @hidden
 */
var DataGridPropertySetter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataGridPropertySetter, _super);
    function DataGridPropertySetter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataGridPropertySetter.prototype.setProperty = function (target_, propertyName_, value_) {
        if (target_ == null) {
            return;
        }
        target_[propertyName_] = value_;
    };
    DataGridPropertySetter.$t = markType(DataGridPropertySetter, 'DataGridPropertySetter', Base.$, [IPropertySetter_$type]);
    return DataGridPropertySetter;
}(Base));
export { DataGridPropertySetter };
//# sourceMappingURL=DataGridPropertySetter.js.map
